export default "__VITE_ASSET__CUZUQQrK__"